import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ILanguageEntry } from '@epicuro-next/platform/i18n';

/**
 * Language Selector Component
 */
@Component({
  selector: 'atx-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LanguageSelectorComponent {
  @Input() public languages: ILanguageEntry[];
  @Input() public activeLanguage: string;
  /**
   * Outputs the selected language id
   */
  @Output() public selectLanguage = new EventEmitter<string>();

  public filteredLanguages() {
    return this.languages.filter((languageEntry) =>
      this.languageIDToCountryCode(languageEntry.id),
    );
  }

  public languageIDToCountryCode(id: string | null) {
    if (!id) return null;
    if (id.includes('-')) {
      return id.toLowerCase().split('-')[1] ?? null;
    } else {
      return id.toLowerCase();
    }
  }

  public handleSelect(id: string) {
    this.selectLanguage.emit(id);
  }

  public isActive(language: ILanguageEntry) {
    return language.id === this.activeLanguage;
  }
}
